import { render, staticRenderFns } from "./ValidationRuleList.vue?vue&type=template&id=0fd6493e"
import script from "./ValidationRuleList.vue?vue&type=script&lang=js"
export * from "./ValidationRuleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports